var FacetLoader;

FacetLoader = (function() {
  function FacetLoader(allFacets, searchFacets, minimumDeals) {
    this.allFacets = allFacets;
    this.searchFacets = searchFacets;
    this.loadedFacets = [];
    this.seekFacets = {};
    this.facetLevelTypes = [];
    this.minDeals = minimumDeals || 3;
    this.facetToFilter = {
      category2: 'subcategory',
      category3: 'subcategory2'
    };
    this.facetSort = function(a, b) {
      return a.order - b.order;
    };
    this.loadFacets = function(facets, level) {
      var facet, i, len, levelType, results;
      results = [];
      for (i = 0, len = facets.length; i < len; i++) {
        facet = facets[i];
        if (this.seekFacets[facet.id] && facet.count > this.minDeals) {
          levelType = this.facetLevelTypes[level];
          this.loadedFacets.push({
            category: facet.id,
            id: facet.id,
            count: facet.count,
            order: this.seekFacets[facet.id],
            name: facet.friendlyNameShort || facet.friendlyName,
            level: level,
            type: levelType,
            query: levelType + ':' + facet.id
          });
        }
        if (facet.children && facet.children.length) {
          results.push(this.loadFacets(facet.children, level + 1));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };
    this.processFacetConfig = function() {
      var facet, facetLevel, facets, i, ind, j, k, len, len1, len2, order, ref, ref1, searchForFacets, type;
      if (this.allFacets && this.allFacets.length && this.searchFacets) {
        facets = this.allFacets;
        searchForFacets = this.searchFacets.split(',');
        order = 1;
        for (i = 0, len = searchForFacets.length; i < len; i++) {
          facet = searchForFacets[i];
          this.seekFacets[facet] = order++;
        }
        for (j = 0, len1 = facets.length; j < len1; j++) {
          facet = facets[j];
          this.facetLevelTypes = facet.id.split('|');
          ref = this.facetLevelTypes;
          for (ind = k = 0, len2 = ref.length; k < len2; ind = ++k) {
            type = ref[ind];
            this.facetLevelTypes[ind] = (ref1 = this.facetToFilter[type]) != null ? ref1 : type;
          }
          facetLevel = 0;
          this.loadFacets(facet.values, facetLevel);
        }
        return this.loadedFacets.sort(this.facetSort);
      }
    };
    this.getCategories = function() {
      return {
        foundCats: this.loadedFacets
      };
    };
    if (searchFacets) {
      this.processFacetConfig();
    }
  }

  return FacetLoader;

})();

module.exports = FacetLoader;

//# sourceMappingURL=data:application/json;base64,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
